var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"could"}},[_c('el-image',{staticClass:"could-animation",attrs:{"ondragstart":"return false","src":require('@/assets/images/cloudBg.png')}}),_vm._v(" "),_c('div',{staticClass:"could-animation1",style:({
      background: ("url(" + (require('@/assets/images/aniCloudBg.png')) + ") repeat-x 0px 0px"),
      backgroundSize: '50% 50%'
    })})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dbdf8c1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myCould.vue
// module id = null
// module chunks = 